import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { InformationWarpPoint } from '../interfaces/information-warp-point';

@Injectable({
  providedIn: 'root'
})
export class InformationWarpPointService {

  constructor(private http: HttpClient) { }

  getInformationWarpPointForRaceAndWarpPointIds(raceId: string, warpPointId: string) {
    if (!warpPointId || !raceId) {
      throw new Error("getInformationWarpPointForWarpPointIdAndRaceId needs non-null warpPointId and raceId");
    }
    return this.http.get<InformationWarpPoint>('/api/informationWarpPoint/warpPointId/' + warpPointId + '/raceId/:raceId' + raceId);
  };

  getInformationWarpPointsForRaceIdAndStarSystemId(raceId: string, starSystemId: string) {
    if (!starSystemId || !raceId) {
      throw new Error("getInformationWarpPointsForRaceIdAndStarSystemId needs non-null raceId and starSystemId");
    }
    return this.http.get<InformationWarpPoint[]>('/api/informationWarpPoint/raceId/' + raceId + '/starSystemId/' + starSystemId);
  };

  getLeanInformationWarpPointsForRaceId(raceId: string) {
    if (!raceId) {
      throw new Error("getLeanInformationWarpPointsForRaceId needs non-null raceId");
    }
    return this.http.get<InformationWarpPoint[]>('/api/informationWarpPoint/raceId/' + raceId);
  }
}
